<!-- Anzeige ZIP-Upload inkl. Form -->
<template>
  <div class="zip__upload">
    <h2>Upload Label-Informationen</h2>
    <p>
      Aktualisierung der Daten:
    </p>
    <form class="zip__upload__form" enctype="multipart/form-data" action="" method="post">
      <input type="file" name="myFile" @change="handleFileChange" ref="fileElement">
      <button type="button" value="upload" @click="doSend" :disabled="isSending || file === ''" :class="{'on-sending':(isSending)}">
        <span class="icon"></span>
        Senden
      </button>
    </form>
    <p class="zip__upload__message--error" v-if="errorMessage !== ''">{{ errorMessage }}</p>
    <p class="zip__upload__message--success" v-if="successMessage !== ''">{{ successMessage }}</p>
  </div>
</template>
<script>
import axios from 'axios'

const URL_FORM = '/api/v1/xml/upload'

export default {
  name: 'ZipUpload',
  components: {},
  props: {},
  data () {
    return {
      file: '',
      isSending: false,
      errorMessage: '',
      successMessage: ''
    }
  },
  methods: {
    handleFileChange (evnt) {
      this.file = this.getFileFromEvent(evnt)
    },
    doSend () {
      this.isSending = true
      const formData = new FormData()
      formData.append('myFile', this.file)
      this.$log.debug('file: ', this.file)

      this.getHttpClient()
        .post(URL_FORM, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          this.$log.debug('response: ', response)
          this.successMessage = 'Die Datei wurde erfolgreich zum Server gesendet!'
          this.errorMessage = ''
          this.isSending = false
          this.$refs.fileElement.value = ''
          this.file = ''
        }, (error) => {
          this.$log.error(error.message)
          this.successMessage = ''
          this.errorMessage = 'Beim Senden der Datei ist ein Fehler aufgetreten: ' + error.message
          this.isSending = false
        })
      // to prevent any action of the form:
      return false
    },
    getFileFromEvent (evnt) {
      return evnt.target.files[0]
    },
    getHttpClient () {
      delete axios.defaults.headers.common.Authorization
      return axios
    }
  }
}
</script>

<style lang="scss">
  .zip__upload {
    margin: 90px auto 160px auto;
    overflow: hidden;
    padding: 1%;
    text-align: left;
    width: 90%;

    .zip__upload__form {
      button span.icon {
        height: 0.9em;
        margin: 0 0 -0.4% 0;
        width: 10px;
        content: ' ';
        display: inline-block;
      }
      button.on-sending span.icon {
        content: url('/img/ajax-loader.gif');
      }
    }
    .zip__upload__message--error {
      color: rgba(217, 20, 4, 1);
      font-weight: bold;
    }
    .zip__upload__message--success {
      color: rgba(120, 217, 4, 1);
      font-weight: bold;
    }
  }
</style>
